import { StepConfig } from './types';
import { ScriptTemplate } from '../../hooks/scripts';
import { SelectOrganizationStep } from './SelectOrganizationStep';
import { UploadSpreadsheetStep } from './UploadSpreadsheetStep';
import { ConfigureScriptStep } from './ConfigureScriptStep';
import { OrgCanonicalScriptsListStep } from './OrgCanonicalScriptsListStep';

export const STEP_KEYS = {
  SELECT_ORGANIZATION: 'select_organization',
  LIST_ORG_CANONICALS: 'list_org_canonicals',
  UPLOAD_SPREADSHEET: 'upload_spreadsheet',
  CONFIGURE_SCRIPT: 'configure_script',
} as const;

export const ERROR_MAP = {
  [STEP_KEYS.SELECT_ORGANIZATION]: 'Por favor, selecione uma organização para continuar',
  [STEP_KEYS.LIST_ORG_CANONICALS]: 'Por favor, selecione um script canônico para continuar',
  [STEP_KEYS.CONFIGURE_SCRIPT]: 'Por favor, configure o script para continuar',
  [STEP_KEYS.UPLOAD_SPREADSHEET]: 'Por favor, faça o upload da planilha para continuar',
} as const;

export const buildStepConfigs = (selectedTemplate?: ScriptTemplate): StepConfig[] => {
  const steps: StepConfig[] = [
    {
      stepKey: STEP_KEYS.SELECT_ORGANIZATION,
      label: 'Escolher Organização',
      component: SelectOrganizationStep,
    },
    {
      stepKey: STEP_KEYS.LIST_ORG_CANONICALS,
      label: 'Selecionar Script',
      component: OrgCanonicalScriptsListStep,
    },
  ];

  if (!selectedTemplate) {
    return steps;
  }

  // Se tem modelDocumentPath, adiciona step de upload
  if (selectedTemplate.modelDocumentPath) {
    steps.push({
      stepKey: STEP_KEYS.UPLOAD_SPREADSHEET,
      label: 'Upload da Planilha',
      component: UploadSpreadsheetStep,
    });
  }

  // Se tem schema, adiciona step de configuração
  if (selectedTemplate.schema) {
    steps.push({
      stepKey: STEP_KEYS.CONFIGURE_SCRIPT,
      label: 'Configurar Script',
      component: ConfigureScriptStep,
    });
  }

  return steps;
};
